import { DefaultWhiteLabelConfig } from "./DefaultWhiteLabelConfig";
import { WhiteLabelConfig, WhiteLabelConfigSchema } from "./types";

let LoadedWhiteLabelConfig: WhiteLabelConfig | null = null;

export function getWhiteLabelConfig(): WhiteLabelConfig {
  if (LoadedWhiteLabelConfig) {
    return LoadedWhiteLabelConfig;
  }

  LoadedWhiteLabelConfig = loadWhiteLabelConfigFromDocument();

  return LoadedWhiteLabelConfig;
}

function loadWhiteLabelConfigFromDocument(): WhiteLabelConfig {
  if (!document) {
    return DefaultWhiteLabelConfig;
  }

  const configElement = document.querySelector("#white-label-config");

  if (!configElement) {
    return DefaultWhiteLabelConfig;
  }

  const result = WhiteLabelConfigSchema.safeParse(
    JSON.parse(configElement.innerHTML),
  );

  if (!result.success) {
    console.error("Invalid white-label config", result.error);

    return DefaultWhiteLabelConfig;
  }

  return result.data;
}
